import { createFileRoute } from "@tanstack/react-router";
import CreateListingV2 from "@/pages/CreateListingV2";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/create-listing-v2/")({
  head: () => routeHead("/create-listing-v2/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><CreateListingV2 /></SubscribedRoute>
  );
}
